import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import { motion } from "framer-motion";

const Navbar = () => {

  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close the menu when the location changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const mobileMenuVariants = {
    closed: { height: 0, opacity: 0, overflow: "hidden" },
    open: { height: "auto", opacity: 1, overflow: "visible" },
  };

  return (
    <nav className="bg-primary shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <h1 className="text-md font-light text-white">TradeRockFx</h1>
          </div>

          <div className="hidden md:flex space-x-8">
            {["/", "/about", "/dashboard", "/contact", "/privacy"].map((path, index) => {
              const label =
                path === "/"
                  ? "Home"
                  : path.substring(1).replace(/^\w/, (c) => c.toUpperCase());
              return (
                <Link
                  key={index}
                  to={path}
                  className={`${
                    location.pathname === path
                      ? "text-primary bg-white"
                      : "text-white hover:text-secondary"
                  } px-4 py-2 rounded-md text-sm font-medium transition-all duration-300`}
                >
                  {label}
                </Link>
              );
            })}
          </div>
       
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white focus:outline-none focus:ring-2 focus:ring-white"
            >
              <svg
                className={`h-6 w-6 transform transition-transform duration-300 ${
                  isOpen ? "rotate-90" : "rotate-0"
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu with Framer Motion */}``
      <motion.div
        className="md:hidden bg-white shadow-lg"
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        variants={mobileMenuVariants}
        transition={{ duration: 0.4, ease: "easeInOut" }}
      >
        {["/", "/about", "/dashboard", "/contact", "/privacy"].map((path, index) => {
          const label =
            path === "/"
              ? "Home"
              : path.substring(1).replace(/^\w/, (c) => c.toUpperCase());
          return (
            <Link
              key={index}
              to={path}
              className={`${
                location.pathname === path
                  ? "text-secondary bg-primaryx"
                  : "text-primary hover:bg-orange-200 hover:text-primaryx"
              } block w-full text-left px-4 py-2 text-sm font-medium`}
            >
              {label}
            </Link>
          );
        })}
      </motion.div>
    </nav>
  );
};

export default Navbar;